@if (isLoading$ | async) {
  <em-spinner class="mt-4 mb-4" [centerContainer]="true"></em-spinner>
} @else {
  @if (supportDefault) {
    @if (isDefault$ | async) {
      <em-warning-box class="mb-2">
        <ng-container title
          >{{ 'MAPPING_ENGINE_DEFUALT_DISCLAIMER_TITLE' | translate }}
        </ng-container>
        <ng-container description
          >{{ 'MAPPING_ENGINE_DEFUALT_DISCLAIMER_DESC' | translate }}
        </ng-container>
        @if ((showDefaultME$ | async) === false) {
          <ng-container actions>
            <em-button (btnClick)="showDefaultMappingEngine()">{{
              'MAPPING_ENGINE_SHOW_DEFAULT' | translate
            }}</em-button>
          </ng-container>
        }
      </em-warning-box>
    } @else {
      <em-info-box class="mb-2">
        <ng-container title
          >{{ 'MAPPING_ENGINE_CUSTOM_DISCLAIMER_TITLE' | translate }}
        </ng-container>
        <ng-container description
          >{{ 'MAPPING_ENGINE_CUSTOM_DISCLAIMER_DESC' | translate }}
        </ng-container>
        <ng-container actions>
          <em-button type="secondary" (btnClick)="revertToDefault()">{{
            'MAPPING_ENGINE_REVERT_TO_DEFAULT' | translate
          }}</em-button>
        </ng-container>
      </em-info-box>
    }
  }
  @if (showNoRulesError) {
    <em-error-box class="mb-2">
      <ng-container title
        >{{ 'MAPPING_ENGINE_NO_RULES_ERROR_TITLE' | translate }}
      </ng-container>
      <ng-container description
        >{{ 'MAPPING_ENGINE_NO_RULES_ERROR_DESC' | translate }}
      </ng-container>
    </em-error-box>
  }
  <div class="compact-theme mt-2 pb-2 shadow-sm">
    <em-input
      class="bg-white"
      [ngModel]="searchTerm"
      [label]="'SHARED_LABEL_SEARCH' | translate"
      [subscriptSizing]="'dynamic'"
      [floatLabel]="'always'"
    >
      <ng-container emPrefix><em-icon name="search"></em-icon></ng-container>
    </em-input>
  </div>
  @if (mappingRulesFormGroup$ | async; as mappingRulesFormGroup) {
    <form
      class="flex flex-col overflow-hidden flex-1"
      [formGroup]="mappingRulesFormGroup"
    >
      @if (filteredMappingRulesControls(); as mappingRulesControls) {
        <div
          class="flex-grow compact-theme overflow-auto drop-list"
          cdkDropList
          [cdkDropListDisabled]="!supportReorder"
          (cdkDropListDropped)="onItemDrop($event)"
        >
          @for (mappinRuleList of mappingRulesControls; track $index) {
            <div cdkDrag class="flex">
              @if (supportReorder) {
                <div cdkDragHandle class="drag-icon-wrapper">
                  <mat-icon>drag_indicator</mat-icon>
                </div>
              }

              <em-readable-mapping-rule-list
                class="flex-1"
                [mappinRuleList]="mappinRuleList"
                [allowDelete]="allowDelete(mappinRuleList.value)"
                [allowReorder]="supportReorder"
                [required]="isRequired(mappinRuleList.value)"
                (moveDown)="changeOrder($index, $index + 1)"
                (moveUp)="changeOrder($index, $index - 1)"
                (moveToFirst)="changeOrder($index, 0)"
                (moveToLast)="
                  changeOrder($index, mappingRulesControls.length - 1)
                "
                (edit)="openEditRuleList(mappinRuleList)"
                (delete)="removeRuleList(mappinRuleList)"
              ></em-readable-mapping-rule-list>
            </div>
          }
        </div>
        <div class="mt-4 flex gap-4">
          <em-button type="secondary" (btnClick)="addNewRuleList(false)"
            >+ {{ 'MAPPING_ENGINE_ADD_NEW_ATTRIBUTE' | translate }}</em-button
          >
          @if (!forceCustomWithoutFlag) {
            <em-button type="secondary" (btnClick)="addNewRuleList(true)"
              >+
              {{
                'MAPPING_ENGINE_ADD_NEW_CUSTOM_ATTRIBUTE' | translate
              }}</em-button
            >
          }

          <div class="ml-auto">
            @if (showCancelBtn) {
              <em-button
                color="basic"
                type="secondary"
                class="mr-2"
                (btnClick)="canceled.emit(true)"
                >{{ 'ACTIONS_CANCEL' | translate }}</em-button
              >
            }
            <em-button class="ml-auto" (btnClick)="saveChanges()">{{
              'SHARED_LABEL_SAVE_CHANGES' | translate
            }}</em-button>
          </div>
        </div>
      }
    </form>
  }
}
